module.exports = __webpack_public_path__ + "AndroidPostit.svg?9a7baa293db161ebe65b3e866eaa33f6";